import { makeStyles } from "@mui/styles";

import theme from "src/theme";
import { appColors } from "src/consts/app-config";
import { MAX_XL_TABLET } from "src/pages/game-new2/constants";

export const useStyles = makeStyles({
    wrapper: {
        width: "100%",
        height: "100%",
        display: "grid",
        gridTemplateRows: "auto auto 1fr",
        gridGap: "16px",
        paddingRight: "45px",
        [theme.breakpoints.down(1536)]: {
            paddingRight: "20px",
        },
        "&.isMobile": {
            [theme.breakpoints.down(MAX_XL_TABLET)]: {
                paddingRight: "0px",
                width: "100%",
                gridTemplateRows: "auto 1fr auto",
                gridTemplateColumns: "1fr",
                justifyContent: "center",
                justifyItems: "center",
                alignItems: "center",
                // gridGap: "16px",
            },
        },
    },
    filterWrapper: {
        width: "100%",
        display: "grid",
        alignItems: "center",
        justifyContent: "space-between",
        gridTemplateColumns: "1fr auto auto",
        gridGap: 16,
        marginTop: 14,
        "&.isMobile": {
            marginBottom: "22px",
            [theme.breakpoints.down(MAX_XL_TABLET)]: {
                display: "flex",
                margin: 0,
                gridGap: 0,
                width: "inherit",
                justifyContent: "flex-start",
                marginBottom: "0px",
            },
        },
    },
    lobbyLabel: {
        color: "#fff",
        fontSize: 24,
        lineHeight: "30px",
        fontWeight: 600,
        margin: 0,
        "&.isMobile": {
            [theme.breakpoints.down(MAX_XL_TABLET)]: {
                fontSize: 22,
                lineHeight: "24px",
                paddingLeft: "14px",
                fontWeight: 400,
            },
        },
    },
    gameListScroll: {
        borderRadius: 12,
        border: "1px solid rgba(255, 255, 255, 0.3)",
        width: "100%",
        background: "none",
        height: "100%",
        "& .ScrollbarsCustom-Scroller": {
            // width: "100%",
        },
        "&.isMobile": {
            [theme.breakpoints.down(MAX_XL_TABLET)]: {
                background: "none",
                width: "100%",
                height: "100%",
                border: "none",
            },
        },
    },
    gameListWrapper: {
        padding: "8px 8px 0px 8px!important",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridRowGap: "8px",
        [theme.breakpoints.down(MAX_XL_TABLET)]: {
            padding: "0px !important",
            gridRowGap: "0px !important",
            maxWidth: 650,
            margin: "0 auto",
        },
    },

    scrollbarMainWrapper: {
        position: "relative",
    },

    thumb: {
        backgroundColor: "#131522 !important",
        width: "7px !important",
        borderRadius: "5px !important",
    },
    track: {
        width: "7px !important",
        height: "calc(100% - 2px) !important",
        top: "0 !important",
        backgroundColor: "#22263D !important",
        borderRadius: "5px !important",
    },
    scroller: {
        paddingRight: 30,
        "@media screen and (max-width: 400px)": {
            paddingRight: 20,
        },
    },

    playMiniButtonWrapper: {
        width: "54px",
        height: "54px",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        zIndex: 1,
        marginRight: "0px",
        "&.chat": {
            width: 50,
            height: 50,
        },
    },

    constBurgerIconWrapper: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    },

    playMiniSvgTextChat: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "fit-content",
        height: "50px",
        alignSelf: "center",
        cursor: "pointer",
        "&.middleText": {
            height: "fit-content",
            margin: 0,
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            color: appColors.white,
            fontWeight: 700,
            textAlign: "center",
        },
        "&.toGame": {
            fontSize: "10px",
        },
        "&.chat": {
            width: "50px",
            height: "50px",
            position: "absolute",
            fontSize: "12px",
        },
        "&.isMaxNumberOfGames": {
            color: appColors.txt950,
            opacity: 0.8,
            fontSize: "11px",
            cursor: "",
        },
    },

    playMiniSvg: {
        [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: "fit-content",
            height: "50px",
            alignSelf: "center",
            cursor: "pointer",
            "&.middleIcon": {
                width: "54px",
                height: "54px",
                borderRadius: "50%",
            },
            "&.middleText": {
                height: "fit-content",
                margin: 0,
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
                color: appColors.white,
                fontWeight: 700,
                textAlign: "center",
            },
            "&.toGame": {
                fontSize: "13px",
            },
            "&.isMaxNumberOfGames": {
                color: appColors.txt950,
                opacity: 0.8,
                fontSize: "11px",
                cursor: "",
            },
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "fit-content",
        height: "50px",
        alignSelf: "center",
        cursor: "pointer",
        "&.chat": {
            width: "50px",
            height: "50px",
            position: "absolute",
            fontSize: "10px",
        },
    },
});
